<template>
  <div class="row">
    <el-drawer title="" :visible.sync="showForm" direction="btt" :before-close="handleClose" size="90%"
      :destroy-on-close="true">
      <div class="row">
        <div class="col-md-3"></div>
        <div class="col-md-6">
          <branch-form @save="getBranches()" v-if="showForm" :branch="selected"></branch-form>
        </div>
      </div>

    </el-drawer>

    <div class="col-md-12 card">
      <div class="card-header">
        <div class="category">Manage Branches</div>
      </div>
      <div class="card-body row">
        <div class="col-sm-6">
          <el-select class="select-default" v-model="pagination.perPage" placeholder="Per page" size="small">
            <el-option class="select-default" v-for="item in perPageOptions" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
          <el-button type="primary" size="small" class="ml-2" @click="handleForm">New +</el-button>
        </div>
        <div class="col-sm-6">
          <div class="pull-right">
            <fg-input class="input-sm" placeholder="Search" v-model="term" addon-right-icon="nc-icon nc-zoom-split">
            </fg-input>
          </div>
        </div>
        <div class="col-sm-12 mt-2">
          <el-table class="table-striped" header-row-class-name="text-primary" :data="branches" style="width: 100%">


            <el-table-column :min-width="120"  class-name="td-actions" label="Name">
              <template slot-scope="props">
                {{ props.row.name }}
              </template>
            </el-table-column>

            <el-table-column :min-width="120"  class-name="td-actions" label="CODE">
              <template slot-scope="props">
                {{ props.row.code }}
              </template>
            </el-table-column>

            <el-table-column :min-width="120"  class-name="td-actions" label="ALLOWED ROUTES">
              <template slot-scope="props">
                {{ props.row.allowed_route_names.join(', ') }}
              </template>
            </el-table-column>

            <el-table-column :min-width="120"  class-name="td-actions" label="ALLOWED ACCOMMODATIONS">
              <template slot-scope="props">
                {{ props.row.allowed_accommodation_names.join(', ') }}
              </template>
            </el-table-column>




            <el-table-column :min-width="120"  class-name="td-actions" label="Actions">
              <template slot-scope="props">

                <el-button type="default" link @click="handleEdit(props.row)" size="mini">
                  <i class="fa fa-edit"></i>
                </el-button>
                <confirm-delete @onClick="handleDelete(props.row)" :label="'Delete'"></confirm-delete>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <p class="category">Found {{ pagination.total }} data</p>
        </div>
        <div class="col-sm-6">
          <p-pagination class="pull-right" v-model="pagination.currentPage" :per-page="pagination.perPage"
            :total="pagination.total">
          </p-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { Branch } from '@/resources/branch'
import ConfirmDelete from '../../Common/ConfirmDelete.vue'
import BranchForm from './BranchForm.vue'

export default {
  components: { ConfirmDelete, BranchForm },
  data() {
    return {
      showDelete: false,
      showForm: false,
      branches: [],
      selected: null,
      perPageOptions: [5, 10, 15],
      pagination: {
        perPage: 10,
        currentPage: 1,
        total: 0
      },
      term: null,
    }
  },
  watch: {
    term: function () {
      if (!this.term || this.term.length > 2) {
        this.getBranches()
      }
    },
    'pagination.perPage': function () {
      if (this.pagination.currentPage == 1) {
        this.getBranches()
      } else {
        this.pagination.currentPage = 1
      }
    },
    'pagination.currentPage': function () {
      this.getBranches()
    }
  },
  created: function () {
    this.getBranches()
  },
  methods: {
    handleEdit(model) {
      this.showForm = true
      this.selected = Object.assign({}, model)
    },
    handleClose() {
      this.showDelete = false
      this.showForm = false
    },
    handleForm() {
      this.showForm = true
      this.selected = null
    },
    handleDelete(model) {
      this.$loading = true
      this.$loadingText = "Removing"

      Branch.delete({ id: model.id })
        .then(result => {
          this.$notify({
            type: 'success',
            title: "Success",
            text: 'Branch has been removed',
          });
          this.getBranches()
        })
        .catch(() => {

        }).finally(() => {
          this.$loading = false
        })
    },
    getBranches() {
      this.handleClose()
      let params = { term: this.term, status: this.status, page: this.pagination.currentPage, per_page: this.pagination.perPage }
      this.$loading = true
      Branch.get({ params: params })
        .then(result => {
          if (result.data.branches)
            this.branches = result.data.branches
        })
        .catch(() => {
          this.$notify({
            type: 'danger',
            title: "Error",
            text: 'Unable to fetch branches',
          });

        }).finally(() => {
          this.$loading = false
        })
    }
  }
}
</script>
<style lang="scss"></style>
